import { getSignInUrl } from '@ankr.com/auth';
import { useMemo } from 'react';

import { AUTH_APP_ID, AUTH_APP_PATH, AUTH_PATH } from '../const';
import { useAuthInstance } from './useAuthInstance';

export interface UseSSOAuthProps {
  hasAPIKeysNotification?: boolean;
  referralCode?: string;
}

export const useSSOAuth = ({
  hasAPIKeysNotification,
  referralCode,
}: UseSSOAuthProps = {}) => {
  const { isSignedIn } = useAuthInstance();

  const signInUrl = useMemo(
    () =>
      getSignInUrl({
        authPath: AUTH_PATH,
        appPath: AUTH_APP_PATH,
        appId: AUTH_APP_ID,
        referralCode,
        hasReferralCodeBox: true,
        hasClickwrapAgreement: true,
        hasAPIKeysNotification,
        referrer: window.location.href,
      }),
    [hasAPIKeysNotification, referralCode],
  );

  const handleSignIn = () => {
    window.location.assign(signInUrl);
  };

  return { handleSignIn, isSignedIn, signInUrl };
};
